export const questionnaire4Questions = [
  {
    id: 'Supervisor attestation_1',
    inputLabel: 'If Yes, please specify:',
    question:
      'Have you participated in any financial arrangements with any person, other than with PIAS , to receive remuneration or overriding benefits based on the provision of any financial advisory service or the sale of any investment product following the provision of any financial advisory service by financial adviser representatives?',

    hasAttachment: true,
  },

  {
    id: 'Supervisor attestation_2',
    inputLabel: 'If Yes, please specify:',
    question:
      'Have you participated in any financial arrangements with any person, other than with PIAS, to pay remuneration or overriding benefits to another individual with supervisory position in PIAS or to any person who does not exercise supervisory duties as a Tier 2 or Tier 3 for the providing supervision over PIAS representatives?',

    hasAttachment: true,
  },
];